(function () {
  const menu = document.getElementById('jasteCustomMenu');
  if (!menu) return;

  const openers = document.querySelectorAll('.js-custom-menu-open');
  const stack = menu.querySelector('.jaste-custom-menu__stack');

  let lastFocus = null;
  let autoCloseTimer = null;

  function isOpen() {
    return menu.classList.contains('is-open');
  }

  function clearAutoClose() {
    if (autoCloseTimer) {
      clearTimeout(autoCloseTimer);
      autoCloseTimer = null;
    }
  }

  function startAutoClose() {
    clearAutoClose();
    autoCloseTimer = setTimeout(() => {
      closeMenu();
    }, 5000);
  }

  function positionStackNearHamburger() {
    if (!stack) return;

    // prende il primo opener “visibile” (utile se ne hai uno desktop + uno mobile)
    const opener = Array.from(openers).find(el => el.offsetParent !== null) || openers[0];
    if (!opener) return;

    const r = opener.getBoundingClientRect();

    // posizione assoluta rispetto alla pagina (quindi resta ferma sul punto in cui l'hai aperta)
    const top = window.scrollY + r.bottom + 12; // 12px sotto l’hamburger
    const left = window.scrollX + r.left - 10;  // -10px per “rientrare” un filo a sinistra

    stack.style.position = 'absolute';
    stack.style.top = top + 'px';
    stack.style.left = left + 'px';
    stack.style.right = 'auto';
  }

  function openMenu() {
    lastFocus = document.activeElement;

    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');

    // NON bloccare scroll
    document.body.classList.remove('jaste-no-scroll');

    // il wrapper non deve bloccare click sul sito
    menu.style.pointerEvents = 'none';
    if (stack) stack.style.pointerEvents = 'auto';

    // posiziona il box dove hai cliccato l’hamburger
    positionStackNearHamburger();

    // focus opzionale
    const input = menu.querySelector('.jaste-custom-menu__search-input');
    if (input) setTimeout(() => input.focus(), 50);

    // avvia auto-chiusura
    startAutoClose();
  }

  function closeMenu() {
    clearAutoClose();

    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');

    // quando è chiuso non intercetta click
    menu.style.pointerEvents = 'none';

    if (lastFocus && typeof lastFocus.focus === 'function') {
      setTimeout(() => lastFocus.focus(), 0);
    }
  }

  function toggleMenu() {
    if (isOpen()) closeMenu();
    else openMenu();
  }

  // Toggle sullo stesso hamburger
  openers.forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggleMenu();
    });
  });

  // ESC chiude
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen()) closeMenu();
  });

  // Stato iniziale
  menu.style.pointerEvents = 'none';
  menu.setAttribute('aria-hidden', 'true');
})();
